import Slider from "react-slick";
import Testimonial from "./Testimonial";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import test1 from "../images/test-1.png"
import test2 from "../images/test-2.png"
import test3 from "../images/test-3.png"

function Testimonials() {
    const settings = {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 1000,
        autoplaySpeed:5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        prevArrow: (
            <div className="custom-prev-arrow">
                <FaChevronRight />
            </div>
        ),
        nextArrow: (
            <div className="custom-next-arrow">
                <FaChevronLeft />
            </div>
        ),
    };
    return (
        <div className="background-with-image relative md:pb-20">
            <div className="container mx-auto flex items-center justify-center bg-[#80a2a5] bg-opacity-0">
                <div className="text-white px-8 pb-10 md:pb-0 rounded-lg text-center w-full">
                    <Slider {...settings}> 
                        <Testimonial
                            customerName='E.G Fortune 500 Marketing Executive Toronto, Canada'
                            customerComment="Thanks to her coaching, I not only achieved the professional milestones I set
for myself, but I also experienced meaningful growth in my personal life. The
clarity and confidence I gained extended well beyond the workplace."
                        />
                           <Testimonial
                            customerImage={test1}
                            customerName='Ayesha Faizi CEO, Eleven Essentials Dallas, Texas'
                            customerComment="She has a unique gift for making you feel seen and heard. Iram guided me
through my thoughts with clarity, helping me step out of my comfort zone and
move toward my goals with confidence. After working with her, I felt more
grounded, motivated, and genuinely capable of pursuing my dreams.
"
                        />
                        <Testimonial
                            customerImage={test2}
                            customerName='Farah F, Professeur de Francais'
                            customerComment="With her guidance, I transformed from feeling stuck and overwhelmed to
standing in my power, making decisions with clarity and confidence. This isn’t
surface-level coaching, it’s soul work."
                        />
                        <Testimonial
                            customerImage={test3}
                            customerName='Aleksandra, Oslo'
                            customerComment="Working with Iram felt like having a wise friend who truly gets it. She helped
me face the perspectives I’d been avoiding and turned my confusion into
clarity. Her gentle guidance made all the difference."
                        />
                        <Testimonial
                            customerName='MB, Florida'
                            customerComment="Since starting coaching, I’ve grown more confident and calm. Each session
gave me clear, actionable direction that strengthened my mental resilience
and gave me a real sense of control over my life.
"
                        />
                    </Slider>
                </div>
            </div>
        </div>
    );
}
export default Testimonials;